import React  from 'react'

import ContributionNotice from '/components/notices/ContributionNotice'

const SetContributionPage = function() {

    return (
        <div className="set-contribution-page">
            <ContributionNotice />
        </div>
    )
}

export default SetContributionPage

